import { DateRangePickerProps } from "@cloudscape-design/components";

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

const UNIT_TO_MS: Record<DateRangePickerProps.TimeUnit, number> = {
  second: 1000,
  minute: 60 * 1000,
  hour: 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
  week: 7 * 24 * 60 * 60 * 1000,
  month: 30 * 24 * 60 * 60 * 1000,
  year: 365 * 24 * 60 * 60 * 1000,
};

export class DateRangeConverter {
  static toDates(value: DateRangePickerProps.Value | null, now: Date = new Date()): DateRange | null {
    if (!value) {
      return null;
    }
    if (value.type === "absolute") {
      const startDate = new Date(value.startDate);
      const endDate = new Date(value.endDate);
      if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime()) || startDate >= endDate) {
        return null;
      }
      return { startDate, endDate };
    }
    if (!Number.isFinite(value.amount) || value.amount <= 0) {
      return null;
    }
    return { startDate: new Date(now.getTime() - value.amount * UNIT_TO_MS[value.unit]), endDate: now };
  }
}
